import { useCallback, useContext, useMemo } from "react";
import { AppThemeContext } from "../../contexts/colors";
import TouchableOpacity from "../Custom/TouchableOpacity";
const Ar = require("../../Assets/Images/ar.png");
const En = require("../../Assets/Images/en.png");
const De = require("../../Assets/Images/de.png");
const Fr = require("../../Assets/Images/fr.png");

export default function LanguageItem({ language, onPress=() => {} }) {
	const {
		dark,
		colors
	} = useContext(AppThemeContext);

	let langItemStyles = useMemo(() => ({
		item: {
			backgroundColor: colors().secondary,
			width: "100%",
			marginLeft: "auto",
			marginRight: "auto",
			height: 80,
			justifyContent: "flex-start",
			alignContent: "center",
			alignItems: "center",
			flexDirection: "row",
			borderRadius: 10,
			marginBottom: 10
		},
		itemText: {
			color: colors().constantWhite,
			width: "75%",
			fontFamily: "monospace",
			fontWeight: language === "ar"
				? "regular"
				: "bold",
			fontSize: 30,
			[language === "ar" ? "marginRight" : "marginLeft"]: 15,
			textAlign: language === "ar" ? "right" : "left"
		}
	}), [dark, language])

	const languagePng = useCallback(() => {
		let langComponent = <div />;
		const imageSize = { value: 60 } //? Define the size of the image

		const imageStyle = {
			width: imageSize.value,
			height: imageSize.value,
			resizeMode: 'cover' //? This will ensure the image covers the entire view
		}

		const imageContainerStyle = {
			width: imageSize.value,
			height: imageSize.value,
			borderRadius: imageSize.value / 2,
			overflow: 'hidden', //? This will clip the parts of the image that exceed the boundaries
			justifyContent: "center",
			alignItems: "center",
			marginLeft: 10
		}
		switch (language) {
			case "ar":
				langComponent = (
					<div style={imageContainerStyle}>
						<img src={Ar} alt="Arabic Logo" style={imageStyle} aspectRatio={1} />
					</div>
				);
				break;

			case "en":
				langComponent = (
					<div style={imageContainerStyle}>
						<img src={En} alt="English Logo" style={imageStyle} aspectRatio={1} />
					</div>
				);
				break;

			case "de":
				langComponent = (
					<div style={imageContainerStyle}>
						<img src={De} alt="German Logo" style={imageStyle} aspectRatio={1} />
					</div>
				);
				break;

			case "fr":
				langComponent = (
					<div style={imageContainerStyle}>
						<img src={Fr} alt="French Logo" style={imageStyle} aspectRatio={1} />
					</div>
				);
				break;
		
			default:
				langComponent = (
					<div style={imageContainerStyle}>
						<img src={Ar} alt="Arabic Logo" style={imageStyle} aspectRatio={1} />
					</div>
				);
				break;
		}
		return langComponent
	}, [language]);

	const languageName = useCallback(() => {
		let langText = "";

		switch (language) {
			case "ar":
				langText = "العربية"
				break;

			case "en":
				langText = "English"
				break;

			case "de":
				langText = "Deutsch"
				break;

			case "fr":
				langText = "Français"
				break;
		
			default:
				langText = "العربية"
				break;
		}
		return langText;
	}, [language])

	return (
		<>
			<TouchableOpacity style={langItemStyles.item} onPress={onPress} activeOpacity={0.7}>
				{languagePng()}
				<h1 style={langItemStyles.itemText}>{languageName()}</h1>
			</TouchableOpacity>
		</>
	);
}